import { render, staticRenderFns } from "./ChallengeAddNew.vue?vue&type=template&id=29e58b45"
import script from "./ChallengeAddNew.vue?vue&type=script&lang=js"
export * from "./ChallengeAddNew.vue?vue&type=script&lang=js"
import style0 from "./ChallengeAddNew.vue?vue&type=style&index=0&id=29e58b45&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports